module.exports = __webpack_public_path__ + "img/logo.0fa73135.svg";